import { ICategory, IMenuProduct } from '@/services/menu-service';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: initialStateType = {
  dialogOpen: false,
  dialogView: null,
  selectedProductInfo: { categoryId: '', productData: null },
  categoryId: '',
  selectedTab: 'All',
};

const stateSlice = createSlice({
  name: 'menuBoard/state',
  initialState: initialState,
  reducers: {
    openDialog: (state) => {
      state.dialogOpen = true;
    },
    closeDialog: (state) => {
      state.dialogOpen = false;
      state.selectedProductInfo = { categoryId: '', productData: null };
      state.categoryId = '';
      state.dialogView = null;
    },
    updateDialogView: (state, action) => {
      state.dialogView = action.payload;
    },
    setSelectedProductInfo: (state, action: PayloadAction<SelectedProductInfo>) => {
      state.selectedProductInfo = action.payload;
    },
    setSelectedCategoryId: (state, action) => {
      state.categoryId = action.payload;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
  },
});

export const { openDialog, updateDialogView, closeDialog, setSelectedProductInfo, setSelectedCategoryId, setSelectedTab } = stateSlice.actions;
export default stateSlice.reducer;
interface initialStateType {
  dialogOpen: boolean;
  dialogView: 'PRODUCT' | 'NEW_PRODUCT' | 'NEW_CATEGORY' | null;
  selectedProductInfo: SelectedProductInfo;
  categoryId: string;
  selectedTab: string;
}

interface SelectedProductInfo {
  categoryId: ICategory['_id'];
  productData: IMenuProduct | null;
}
